import { PAGE_PATH } from "../../path";
import { permissions, settings } from "../../shim/jsbridge";

import { DEFAULT_YARA_URL_PARAMS } from "../yara/dashboard/consts";
import { LOCATION } from "../search/consts";

const { FEATURE_PIVOT_SEARCH } = settings || {};

export const RL_NAVIGATION_ITEM_LABELS = {
  DASHBOARD: "Dashboard",
  SEARCH: "Search & Submissions",
  YARA: "Yara",
  GRAPH: "Graph"
};

export const getNavigationRoutes = (viewingUrlPage?: boolean) => [
  {
    url: PAGE_PATH.DASHBOARD,
    label: RL_NAVIGATION_ITEM_LABELS.DASHBOARD,
    additionalClassName: "main-nav__item--dashboard",
    visible: true,
    allowedPermissions: [],
    linkReloadsDocument: false
  },
  {
    url: `${PAGE_PATH.SEARCH}${
      viewingUrlPage ? `?location=${LOCATION.NETWORK}` : ""
    }`,
    label: RL_NAVIGATION_ITEM_LABELS.SEARCH,
    additionalClassName: "main-nav__item--samples-search",
    visible: FEATURE_PIVOT_SEARCH,
    allowedPermissions: [],
    linkReloadsDocument: false
  },
  {
    url: `${PAGE_PATH.YARA}${DEFAULT_YARA_URL_PARAMS}`,
    additionalClassName: "main-nav__item--yara",
    label: RL_NAVIGATION_ITEM_LABELS.YARA,
    visible: true,
    allowedPermissions: [permissions.VIEW_YARA],
    linkReloadsDocument: false
  },
  {
    url: PAGE_PATH.GRAPH_MANAGER,
    additionalClassName: "main-nav__item--graph",
    label: RL_NAVIGATION_ITEM_LABELS.GRAPH,
    visible: settings.FEATURE_GRAPH_EXPLORER,
    allowedPermissions: [],
    linkReloadsDocument: false
  }
];
